import API from './api';

const VAPID_PUBLIC_KEY =
  // Vite stil
  (typeof import.meta !== 'undefined' &&
    import.meta.env &&
    import.meta.env.VITE_VAPID_PUBLIC_KEY) ||
  // CRA stil
  process.env.REACT_APP_VAPID_PUBLIC_KEY ||
  '';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function initWebPush() {
  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.log('Push not supported in this browser');
      return;
    }

    if (!VAPID_PUBLIC_KEY) {
      console.warn('VAPID public key missing in FE env');
      return;
    }

    // već registrisan?
    let registration = await navigator.serviceWorker.getRegistration();
    if (!registration) {
      registration = await navigator.serviceWorker.register('/sw.js');
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notifications permission not granted');
      return;
    }

    const existingSub = await registration.pushManager.getSubscription();
    if (existingSub) {
      await API.post('/push/subscribe', existingSub.toJSON());
      return;
    }

    const appServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appServerKey,
    });

    await API.post('/push/subscribe', subscription.toJSON());
  } catch (err) {
    console.error('initWebPush error', err);
  }
}
